module.exports = __webpack_public_path__ + "static/media/ios-messages-icon.09ae1df6.png";